document.querySelector("#CollectionProductGrid").addEventListener("click", (e) => {
  let isLoading = false;
  if (e.target.classList.contains("ts-quick__option")) {
    e.preventDefault();
    const variantId = e.target.dataset.id;
    const isDisabled = e.target.classList.contains("ts-quick__option--disabled");
    if (!isLoading && !isDisabled) {
      isLoading = true;
      let formData = {
        'items': [{id: variantId,quantity: 1}],
        "sections": "modal-cart"
      };
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      }).then(response => response.json()).then(response => {
        const cartModalHtml = new DOMParser().parseFromString(response.sections['modal-cart'], "text/html");
        fetch(window.Shopify.routes.root + 'cart.js').then((response) => response.json()).then(response => {
          if (cartModal) {
            console.log(response);
            cartModal.cartContainer.innerHtml = cartModalHtml.innerHtml;
            cartModal.buildCart(response);
            cartModal.modal.show();
            isLoading = false;
          }
        })
      })
    }
  }
})